module.exports = __webpack_public_path__ + "static/media/Full-Container-Load.5b5e3069.jpg";